import { CheckCircle, AlertCircle, Info, Download, Eye } from 'lucide-react';
import { Button } from '../ui/button';

const REUSSI = ['admis', 'reussi', 'recu'];

const TONS = {
  admis: { cadre: 'bg-green-50 border-green-500', titre: 'text-green-800', Icone: CheckCircle, icone: 'text-green-500' },
  refuse: { cadre: 'bg-red-50 border-red-500', titre: 'text-red-800', Icone: AlertCircle, icone: 'text-red-500' },
  info: { cadre: 'bg-blue-50 border-blue-500', titre: 'text-blue-800', Icone: Info, icone: 'text-blue-500' },
};

const TITRES = {
  admis: 'Félicitations ! Vous êtes accepté(e) pour la formation BPJEPS Motonautisme',
  refuse: "Votre candidature n'a pas été retenue",
  info: 'Résultats de vos tests de sélection disponibles',
};

const Epreuve = ({ label, valeur }) => (valeur ? (
  <div className="bg-white/60 rounded p-2">
    <p className="text-xs text-slate-500">{label}</p>
    <p className={`font-bold ${REUSSI.includes(valeur) ? 'text-green-700' : 'text-red-700'}`}>{valeur.toUpperCase()}</p>
  </div>
) : null);

const BoutonsDocument = ({ libelle, onVoir, onTelecharger, principal, testId }) => (
  <div className="flex gap-2 w-full sm:w-auto">
    <Button
      onClick={onTelecharger}
      variant={principal ? 'default' : 'outline'}
      className={`flex-1 sm:flex-none h-auto py-2 whitespace-normal ${principal ? 'bg-green-600 hover:bg-green-700 text-white' : 'bg-white'}`}
      data-testid={`btn-${testId}`}
    >
      <Download className="h-4 w-4 mr-2 flex-shrink-0" />
      Télécharger {libelle}
    </Button>
    <Button onClick={onVoir} variant="outline" className="bg-white h-auto py-2" title={`Voir ${libelle}`} data-testid={`btn-voir-${testId}`}>
      <Eye className="h-4 w-4" />
    </Button>
  </div>
);

// Résultats des tests : affichés en permanence côté candidat dès qu'ils existent
export const ResultatsTestsBanner = ({ resultat, statut, lettre, attestation }) => {
  const global = resultat?.resultat_global;
  if (!global && !resultat?.epreuve_vnm_bras && !resultat?.epreuve_vnm_selle && !resultat?.epreuve_entretien) return null;
  const admis = ['admis', 'recu'].includes(global) || statut === 'accepte';
  const ton = admis ? 'admis' : (statut === 'refuse' || global) ? 'refuse' : 'info';
  const { cadre, titre, Icone, icone } = TONS[ton];

  return (
    <div className={`p-4 rounded-lg border-l-4 shadow-md ${cadre}`} data-testid="tests-resultats-banner">
      <div className="flex items-start gap-3">
        <Icone className={`h-6 w-6 flex-shrink-0 ${icone}`} />
        <div className="flex-1 min-w-0">
          <h3 className={`font-bold ${titre}`}>{TITRES[ton]}</h3>
          <div className="mt-3 grid grid-cols-2 md:grid-cols-4 gap-3 text-sm">
            <Epreuve label="VNM à bras" valeur={resultat.epreuve_vnm_bras} />
            <Epreuve label="VNM à selle" valeur={resultat.epreuve_vnm_selle} />
            <Epreuve label="Entretien" valeur={resultat.epreuve_entretien} />
            {global && (
              <div className={`rounded p-2 ${['admis', 'recu'].includes(global) ? 'bg-green-100' : 'bg-red-100'}`}>
                <p className="text-xs text-slate-500">Résultat global</p>
                <p className={`font-bold ${['admis', 'recu'].includes(global) ? 'text-green-700' : 'text-red-700'}`} data-testid="tests-resultat-global">
                  {['admis', 'recu'].includes(global) ? 'ADMIS' : 'NON ADMIS'}
                </p>
              </div>
            )}
          </div>
          {resultat.commentaires && (
            <p className="text-sm mt-3 text-slate-700 bg-white/50 rounded p-2">
              <span className="font-medium">Commentaires : </span>{resultat.commentaires}
            </p>
          )}
          {global && (
            <div className="mt-4 flex flex-wrap gap-2">
              {['admis', 'recu'].includes(global) && (
                <BoutonsDocument libelle="ma lettre de réussite" principal testId="lettre-reussite" {...lettre} />
              )}
              <BoutonsDocument libelle="mon attestation de sélection" testId="attestation-selection" {...attestation} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
